module.exports = __webpack_public_path__ + "img/quizz-step-8-4.5886f504.jpg";